import { ThemeProperties } from '@fluidx/office-fluid-types';
import { ThemeFontsCssPropertyName, ThemeLayoutCssPropertyName } from '@fluidx/component-ux';

// We'll populate these once the hosts have started using this styling provider for their Meeting scenario.

/*
 * Theming properties that are used with the meeting notes within calendar view scenario.
 */
export const MeetingNotesCalendarViewThemingDefaults: ThemeProperties = new Map([
  [ThemeFontsCssPropertyName.FontSizeHeading1, '14px'],
  [ThemeFontsCssPropertyName.FontSizeHeading2, '14px'],
  [ThemeFontsCssPropertyName.FontSizeHeading3, '14px'],
  [ThemeFontsCssPropertyName.FontSizeBody, '14px'],
  [ThemeLayoutCssPropertyName.MarginTopHeading1, '24px']
]);
